"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
exports.events = ['mousedown', 'touchstart'];
var ClickOutsideDetector = /** @class */ (function (_super) {
    __extends(ClickOutsideDetector, _super);
    function ClickOutsideDetector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        _this.handleClickOut = function (_a) {
            var target = _a.target;
            var ignore = _this.props.ignore;
            var isIgnored = ignore &&
                ignore.some(function (_a) {
                    var current = _a.current;
                    return (current && current.contains(target)) || false;
                });
            if ((target && _this.ref.current && _this.ref.current.contains(target)) || isIgnored) {
                return;
            }
            _this.props.onClickOutside();
        };
        return _this;
    }
    ClickOutsideDetector.prototype.componentDidMount = function () {
        var _this = this;
        exports.events.forEach(function (event) {
            window.addEventListener(event, _this.handleClickOut, true);
        });
    };
    ClickOutsideDetector.prototype.componentWillUnmount = function () {
        var _this = this;
        exports.events.forEach(function (event) {
            window.removeEventListener(event, _this.handleClickOut, true);
        });
    };
    ClickOutsideDetector.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children;
        return React.createElement("div", { ref: this.ref, className: classNames(className) }, children);
    };
    return ClickOutsideDetector;
}(React.Component));
exports.default = ClickOutsideDetector;
